import { useTheme } from '@mui/material';
import { type FC, useMemo } from 'react';

import { useSlabQuery } from '@web/hooks/useSlabQuery';

import { buildJobSitePins } from './mapPins';
import { PinMarkers, type PinMarkersProps } from './PinMarkers';

export const JobSiteMarkers: FC<PinMarkersProps> = (props) => {
  const theme = useTheme();
  const { data: projectMapPins } = useSlabQuery('GET project map pins', {});

  const pins = useMemo(
    () => buildJobSitePins(projectMapPins ?? [], theme),
    [projectMapPins, theme],
  );

  return <PinMarkers pins={pins} {...props} />;
};
